import { useLocalizable } from '@contexts/LocalizableContext'
import { Perk as PerkModel } from '@models/membership/Perk'
import { useAppSelector } from '@store/hooks'
import { selectPerkById } from '@store/membership/PerkReducer'
import { SBModelComponent } from '@supplement-bacon/react-toolkit/models'
import { Flex, Typography } from 'antd'
import { FC } from 'react'
import { langList } from '../../factories/Utils'

const { Title, Paragraph } = Typography

type Props = SBModelComponent<PerkModel> & {}

const PerkAvatar: FC<Props> = ({ id, model }) => {
  const localizable = useLocalizable()

  const langCode = localizable?.langCode ?? langList[0].code
  const item = model ?? useAppSelector(selectPerkById(id!))

  if (!item) {
    return <></>
  }
  return (
    <Flex gap={0} vertical>
      <Title level={5} className="m-0">
        {item[langCode].title}
      </Title>
      <Paragraph
        ellipsis={{ rows: 4, tooltip: true }}
        style={{ marginBottom: 0 }}
        type="secondary"
      >
        {item[langCode].caption}
      </Paragraph>
      <Paragraph
        ellipsis={{ rows: 4, tooltip: true }}
        style={{ marginBottom: 0 }}
        type="secondary"
      >
        {item[langCode].description}
      </Paragraph>
    </Flex>
  )
}

type PerkAvatarType = { Avatar: typeof PerkAvatar }

export { PerkAvatar, type PerkAvatarType }
